<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SrxyCu/tc-custom/9781455621057.jpg?1728259255624" alt="This image is the cover for the book Lone Star Legacy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lone Star Legacy
      </h1>
      <p class="bookDescription body article font2">
        <p>   </p><p> Learn about the men behind the legendary star in this exciting new book for all ages! Texas native Melanie Chrismer takes readers through the two hundred-year-history of the Texas Rangers and the changes that took place in the state from the organization’s inception to its current incarnation. Emphasis is placed on the diversity of those who assisted the Rangers, including Native Americans, Texans of Mexican heritage, and African Americans, along with the newest addition—women rangers. Covering the creation of the Rangers as a response to territorial conflict, their role under the Republic, their defense against Mexican invaders, and their evolution during the twentieth century, Chrismer has created the perfect resource for the classroom. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Melanie Chrismer
      </h2>
      
      <p class="authorDescription body article"><P> &#160; </P><P> A fifth-generation Houstonian and full-time writer, Melanie Chrismer attended both Texas A&amp;M University and Houston Baptist University. She frequently speaks at schools and libraries, giving presentations on developing writing strategies and the history of Texas as well as roping demonstrations with her practice bull, Medium-Rare. She is a member of the Society of Children&rsquo;s Book Writers and Illustrators, Women Writing the West, the Texas Coalition of Authors, and the International Reading Association. Chrismer is the author of several children&rsquo;s books published by Pelican;&#160;<B><I>Phoebe Clappsaddle has a Tumbleweed Christmas</I></B>,&#160;<B><I>Phoebe Clappsaddle for Sheriff</I></B>,&#160;<B><I>Phoebe Clappsaddle and the Tumbleweed Gang,&#160;</I></B>and<B>&#160;<I>Chachalaca Chiquita.</I></B></P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing Conpany
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10d8aa72